import i18next from "i18next";
import { LOCALES } from "./locales";
import resources from "./resources";

export const initIntl = () =>
  i18next.init({
    lng: LOCALES.ENGLISH,
    fallbackLng: LOCALES.ENGLISH,
    interpolation: { escapeValue: false },
    resources,
  });
